/**
 * Принимает на вход простую текстовую строку, а возвращает HTML-размеченный rich-текст
 * @param text
 */
export const textToHtml = (text: string) =>
    text.split("\n").map((item, key) =>
        <span key={key} dangerouslySetInnerHTML={{__html: item + '<br/>'}}/>
    );